/* unplugin-vue-components disabled */import script from "./flowPermissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./flowPermissionModal.vue?vue&type=script&setup=true&lang=js"

import "./flowPermissionModal.vue?vue&type=style&index=0&id=2a498b39&lang=scss"

const __exports__ = script;

export default __exports__